import { gql } from "@apollo/client";

export const UPDATE_OFFERING = gql`
  mutation updateOffering($params: OfferingUpdateInput!) {
    updateOffering(params: $params) {
      id
      title
      offeringType
      target
      price
      offerPrice
      currency
      offeringStatus
      expireAt
    }
  }
`;
